module.exports = __webpack_public_path__ + "static/img/account_icon4.0e16884d.png";